import { getApp } from "firebase/app";
import { getFirestore, collection } from "firebase/firestore";
// =============================== BASE  ===============================  //
const app = getApp();

export const REF = {
  NAME: "finance",
  COLLECTIONS: {
    MANAGER: "manager",
    LIFE: "life",
  },
};

export const getRefs = () => {
  const firestore = getFirestore(app, REF.NAME);
  const CREF = {
    manager: collection(firestore, REF.COLLECTIONS.MANAGER),
    life: collection(firestore, REF.COLLECTIONS.LIFE),
  };
  return CREF;
};
